import type { PlantedSpecies } from '@planet-sdk/common';

import { useCallback } from 'react';
import styles from '../../styles/InterventionInfo.module.scss';
import { useLocale, useTranslations } from 'next-intl';
import { getFormattedNumber } from '../../../../../utils/getFormattedNumber';

interface Props {
  totalTreesCount: number;
  plantedSpecies: PlantedSpecies[];
  plantProject: string | undefined;
}

const SpeciesPlanted = ({
  totalTreesCount,
  plantedSpecies,
  plantProject,
}: Props) => {
  const tProjectDetails = useTranslations('ProjectDetails');
  const locale = useLocale();
  const getPlantedTreePercentage = useCallback(
    (treeCount: number) => {
      const result = (treeCount / totalTreesCount) * 100;
      if (Number.isInteger(result)) {
        return result;
      }
      return result.toFixed(1);
    },
    [totalTreesCount]
  );
  const getSpeciesName = (species: PlantedSpecies) => {
    // TODO: Remove special case for Volcano Valley once data is consistent.
    // Currently: use `scientificName`, falling back to `otherSpecies` only for this project.
    if (plantProject === 'proj_eKBbIt7Bzavu9o7xzCAqjS2t') {
      return species.scientificName || species.otherSpecies;
    }
    return species.scientificName;
  };

  return (
    <div className={`species-container ${styles.speciesContainer}`}>
      <h2>
        {tProjectDetails('speciesCount', {
          count: plantedSpecies.length,
        })}
      </h2>
      <div className={styles.speciesSubContainer}>
        {plantedSpecies?.map((species) => (
          <div className={styles.speciesList} key={species.id}>
            <p className={styles.speciesName}>{getSpeciesName(species)}</p>
            <div className={styles.treeMetrics}>
              <p>{getFormattedNumber(locale, species.treeCount)}</p>
              <p>{`${getPlantedTreePercentage(species.treeCount)}%`}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SpeciesPlanted;
